import { Ref } from 'vue';
import { Router } from 'vue-router';

import { ExtendedMenuOption, menuOptionBuilder } from '@/utils/builder.util';

export const borrowDetailOptions = (
  selectedDatum: Ref<
    | {
        _id: string;
        isReportDone: boolean;
        isUnderRepair: boolean;
        isUnderTracking: boolean;
        isManager: boolean;
      }
    | undefined
  >,
  router: Router,
  shows: {
    showReportDamage: Ref<boolean>;
    showReportMissing: Ref<boolean>;
    showCancelBorrowingTransaction: Ref<boolean>;
    showCancelExtensionRequest: Ref<boolean>;
    showDeclineExtensionRequest: Ref<boolean>;
    showBorrowingLog: Ref<boolean>;
    showAssetConfirmation: Ref<boolean>;
    showCancelReport: Ref<boolean>;
  },
): ExtendedMenuOption[] => [
  menuOptionBuilder(
    'Return',
    'arrow-go-back-line',
    (): void => {
      if (!selectedDatum.value) return;
      sessionStorage.setItem(
        'assetBorrowReturn',
        JSON.stringify([selectedDatum.value._id]),
      );

      router.push({
        name: 'AssetBorrowBorrowedReturnAssetView',
      });
    },
    ['On Borrowing'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Request Extension',
    'extension-borrow',
    (): void => {
      if (!selectedDatum.value) return;
      sessionStorage.setItem(
        'assetBorrowRequestExtension',
        JSON.stringify([selectedDatum.value._id]),
      );

      router.push({
        name: 'AssetBorrowTransactionExtensionRequestView',
      });
    },
    ['On Borrowing'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Report Damage',
    'user-settings',
    (): void => {
      // Show the report damage dialog.
      shows.showReportDamage.value = true;
    },
    ['On Borrowing'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Report Missing',
    'user-search',
    (): void => {
      // Show the report missing dialog.
      shows.showReportMissing.value = true;
    },
    ['On Borrowing'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Approval',
    'chat-check-line',
    (): void => {
      if (!selectedDatum.value) return;
      sessionStorage.setItem(
        'assetBorrowExtendApproval',
        JSON.stringify([selectedDatum.value._id]),
      );

      router.push({
        name: 'AssetBorrowTransactionExtendApprovalView',
      });
    },
    ['Request Extension'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Confirmation',
    'chat-check-line',
    (): void => {
      shows.showAssetConfirmation.value = true;
    },
    ['Waiting for Confirmation'],
    undefined,
    (selectedDatum.value ? !!selectedDatum.value.isReportDone : false) &&
      selectedDatum.value?.isManager,
  ),
  menuOptionBuilder('Borrowing Log', 'file-list-2', (): void => {
    shows.showBorrowingLog.value = true;
  }),
  menuOptionBuilder(
    'Edit Extension Request',
    'edit',
    (): void => {
      if (!selectedDatum.value) return;

      sessionStorage.setItem('assetBorrowRequestExtensionMode', 'Edit');

      sessionStorage.setItem(
        'assetBorrowRequestExtension',
        JSON.stringify([selectedDatum.value._id]),
      );

      router.push({
        name: 'AssetBorrowTransactionExtensionRequestView',
      });
    },
    ['Extend Approval'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Cancel Report',
    'close',
    (): void => {
      shows.showCancelReport.value = true;
    },
    ['Reported Damaged', 'Reported Missing'],
    true,
    (selectedDatum.value
      ? (selectedDatum.value.isUnderRepair === false &&
          selectedDatum.value.isReportDone !== true) ||
        (selectedDatum.value.isUnderTracking === false &&
          selectedDatum.value.isReportDone !== true)
      : false) && selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Decline Request',
    'close',
    (): void => {
      shows.showDeclineExtensionRequest.value = true;
    },
    ['Request Extension'],
    true,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Cancel Extension Request',
    'close',
    (): void => {
      shows.showCancelExtensionRequest.value = true;
    },
    ['Extend Approval'],
    true,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Cancel Borrowing',
    'close',
    (): void => {
      shows.showCancelBorrowingTransaction.value = true;
    },
    ['Waiting for Approval', 'Waiting for Handover'],
    true,
    selectedDatum.value?.isManager,
  ),
];

export const borrowDetailChildrenOptions = (
  selectedDatum: Ref<
    | {
        _id: string;
        isReportDone: boolean;
        isUnderRepair: boolean;
        isUnderTracking: boolean;
        isManager: boolean;
      }
    | undefined
  >,
  shows: {
    showReportDamage: Ref<boolean>;
    showReportMissing: Ref<boolean>;
    showBorrowingLog: Ref<boolean>;
  },
): ExtendedMenuOption[] => [
  menuOptionBuilder(
    'Report Damage',
    'user-settings',
    (): void => {
      // Show the report damage dialog.
      shows.showReportDamage.value = true;
    },
    ['On Borrowing'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder(
    'Report Missing',
    'user-search',
    (): void => {
      // Show the report missing dialog.
      shows.showReportMissing.value = true;
    },
    ['On Borrowing'],
    undefined,
    selectedDatum.value?.isManager,
  ),
  menuOptionBuilder('Borrowing Log', 'file-list-2', (): void => {
    shows.showBorrowingLog.value = true;
  }),
];
